import AccountOrganizationsPage from '@/apps/account/views/Organizations';
import { LOGIN_CONTEXT } from './utils/login';
import LoginPage from './views/Login';
import WelcomePage from './views/Welcome';

export const authPublicRoutes = [
  {
    path: '/',
    name: '登录',
    element: <LoginPage loginContext={LOGIN_CONTEXT.TENANT} />,
  },
  {
    path: '/admin/login',
    name: '平台登录',
    element: <LoginPage loginContext={LOGIN_CONTEXT.ADMIN} />,
  },
];

export const authProtectedRoutes = [
  {
    path: '/welcome',
    name: '暂无可用组织',
    element: <WelcomePage />,
  },
  {
    path: '/organizations',
    name: '组织管理',
    element: <AccountOrganizationsPage />,
  },
];

export const authLayoutRoutes = [...authPublicRoutes, ...authProtectedRoutes];
